
import { defineComponent } from '@vue/composition-api'
import ggoApi from '@/modules/ggo-api'
import MapLocation from '@/classes/MapLocation'

export default defineComponent({
  async asyncData ({ params, redirect, localePath, query: _query, error }) {
    if (!params.brief) throw new Error('Missing `params.biref`!')

    const { success, data } = await ggoApi.getDistrict({
      brief: params.brief,
    })

    if (!success || !data) {
      error({ statusCode: 404 })
      return
    }

    const query = {
      ...data,
      ..._query,
      maxDistance: String(MapLocation.getMaxDistance(data.country)),
    }

    redirect(301, localePath('/car/search'), query)
  },
})
